import getOnClickPayload from './onClickEventsMapper'
import getPageviewPayload from './pageViewEventsMapper'
import { isWindow } from './sessionUtils'
import { LANGUAGE_TYPE } from '../constants/tealiumData'
import { getCustomerTypeCode } from './tealiumUtils'

const OLB = 'OLB'
const OMNI = 'omni'

const getDeviceType = () => {
  const channelType =
    sessionStorage.getItem('channelId') || sessionStorage.getItem('Channel')

  switch (channelType) {
    case 'iOSRebraded':
      return 'iphone rebranded'

    case 'android rebranded':
      return 'android rebranded'

    case 'ipad rebranded':
      return 'ipad rebranded'

    case OLB:
      return 'desktop'

    case 'TUX':
      return 'touch'
    default:
      return 'desktop'
  }
}
const getChannel = () => {
  const channelType =
    sessionStorage.getItem('channelId') || sessionStorage.getItem('Channel')
  let channel = ''
  if (channelType?.toLowerCase() === 'tux') channel = 'MBL'
  else if (isWindow()) channel = window.appNameForSiteCat
  else channel = OLB
  return channel
}

const globalData = {
  channel: getChannel(),
  customerSegment: getCustomerTypeCode(),
  deviceType: getDeviceType(),
  languageType:
    sessionStorage.getItem('Language') === 'es'
      ? LANGUAGE_TYPE.SPANISH
      : LANGUAGE_TYPE.ENGLISH,
  sitePlatform: OMNI,
  // uxNameForSiteCat: isWindow() ? window.uxNameForSiteCat : DESKTOP,
  pageComponents: 'open bill pay'
}

let pageViewCounter = 0
function TealiumEvent(ad) {
  let timer
  if (isWindow() && window.publisherFW) {
    window.publisherFW.publishEvent(ad.datasource, ad)
    clearTimeout(timer)
  } else if (pageViewCounter < 100) {
    pageViewCounter += 1
  }
}

async function LoadTealiumEvent(reportingData) {
  TealiumEvent({
    ...globalData,
    ...reportingData
  })
}
function PageviewTealiumEvent(currentRoute, payload) {
  const tealiumDataLayerObj = getPageviewPayload(currentRoute, payload)
  LoadTealiumEvent(tealiumDataLayerObj)
}

function OnclickTealiumEvent(event, payload) {
  const tealiumDataLayerObj = getOnClickPayload(event, payload)
  LoadTealiumEvent(tealiumDataLayerObj)
}

export { LoadTealiumEvent, PageviewTealiumEvent, OnclickTealiumEvent }
